module.exports = __webpack_public_path__ + "static/img/doc-back.794a407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/regionalServiceProject/images/doc-back.jpg
// module id = HyON
// module chunks = 5